export default __webpack_public_path__ + "static/media/accessibility.f23bc64d.jpg";